module.exports = __webpack_public_path__ + "public/img/bg.c5de7856.png";